<template>
    <div class="no-data-shell">
        <div class="data-icon" :style="'width: '+width+';height: '+height+';'">
            <img :src="icon" alt="">
<!--            <div class="tips">-->
<!--                {{tips}}-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
  export default {
    name: 'no-data',
    props: {
      icon: {
        type: String,
        default: require('@/assets/no-data.png')
      },
      type: {
        type: [Number, String],
        default: 'data'
      },
      width: {
        type: String,
        default: '200px;'
      },
      height: {
        type: String,
        default: '200px;'
      },
      tips: {
        type: String,
        default: '暂无数据'
      }
    },
    data () {
      return {}
    },
    methods: {}
  }
</script>

<style lang="less" scoped>
    .no-data-shell {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50%;
        height: 50%;
        margin: 10% auto;
    }
</style>
